import { Box, Group, Loader } from '@mantine/core';
import * as icons from '@sloyd/icons';
import { $a } from 'shared-base';
import { Button } from '../Button/Button';
import ClientSwitcher from '../ClientSwitcher/ClientSwitcher';
import Credits from '../Credits/Credits';
import Logo from '../Logo/Logo';
import classes from './TopBar.module.css';
import { Gap, Indicator } from './TopBar.style';

export type TopBarProps = {
  section: string;
  data: {
    user: IUser;
    isSignedIn?: boolean;
    isLoading?: boolean;
    isSlimVersion?: boolean;
    children: React.ReactNode;
    version: string;
  };
  callbacks: {
    onLogoClick: () => void;
    onAction: OnAction;
    onNavigate: (path: string) => void;
    toggleLogs: () => void;
  };
};

export function TopBar(props: TopBarProps) {
  const { data, callbacks, section } = props;
  const { user, version, isSlimVersion, isLoading } = data;
  const { isPayingUser, isEmployee } = user;

  function buyCredits() {
    callbacks.onAction($a('PURCHASE', 'credits'));
  }

  function renderInner() {
    return (
      <Group visibleFrom='sm'>
        <Credits user={user} />
        {!isPayingUser && (
          <Button
            onClick={() => callbacks.onNavigate('/pricing')}
            size='xs'
            variant='gradient'
            radius='xl'
          >
            Upgrade
          </Button>
        )}

        <Button
          size='xs'
          variant='filled'
          color='pink'
          radius='xl'
          leftSection={<icons.Icon360View />}
          onClick={() => callbacks.onNavigate('/playground/blank')}
        >
          Create
        </Button>
      </Group>
    );
  }

  function renderClientSwitcher() {
    if (!isEmployee) return null;
    return <ClientSwitcher />;
  }

  return (
    <Box>
      <header className={classes.header}>
        <Group justify='space-between' h='100%'>
          <Logo tagline={section} onClick={callbacks.onLogoClick} version={version} />
          <Indicator>{isLoading && <Loader size='xs' color='pink' />}</Indicator>
          {renderClientSwitcher()}
          {isEmployee && (
            <Button onClick={callbacks.toggleLogs} size='xs' variant='subtle' radius='xl'>
              Show Logs (`)
            </Button>
          )}
          <Gap />
          <Button variant='subtle' onClick={() => callbacks.onNavigate('/pricing')}>
            Pricing
          </Button>
          {renderInner()}
        </Group>
      </header>
    </Box>
  );
}

export default TopBar;
